
define("rv!templates/vacationdetails",[],function(){return { v:3,
  t:[ { t:7,
      e:"link",
      a:{ rel:"stylesheet",
        href:"https://fh-kit.com/buttons/v2/?red=cc0000∨ange=ff6000&green=3AB134",
        type:"text/css",
        media:"screen" } },
    " ",
    { t:7,
      e:"br",
      a:{ "class":"clear" } },
    " ",
    { t:4,
      f:[ " ",
        { t:7,
          e:"span",
          a:{ "class":"alert alert-danger",
            style:"display: block;" },
          f:[ { t:3,
              r:"data.LabelError" } ] } ],
      n:50,
      x:{ r:[ "data.LabelError" ],
        s:"_0!=\"\"" } },
    { t:4,
      n:51,
      f:[ { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"h1",
          a:{ "class":"print-only span12" },
          f:[ "DIRECT BILL ADESTINN" ] },
        " ",
        { t:7,
          e:"div",
          a:{ "class":"span4",
            id:"vacationDetailsBookspan4" },
          f:[ { t:7,
              e:"div",
              f:[ { t:7,
                  e:"div",
                  f:[ { t:3,
                      r:"data.BookedByUsername" } ] },
                " ",
                { t:7,
                  e:"div",
                  f:[ { t:3,
                      r:"data.CanceledByUserName" } ] },
                " ",
                { t:7,
                  e:"h3",
                  f:[ { t:2,
                      r:"data.LabelVacationName" },
                    " ",
                    { t:7,
                      e:"a",
                      a:{ href:[ "/VacationCalendar.aspx?did=",
                          { t:2,
                            r:"data.vacDestId" } ],
                        title:"Click to download a calendar event" },
                      f:[ { t:7,
                          e:"i",
                          a:{ "class":"icon-calendar" } } ] } ] },
                " Created: ",
                { t:2,
                  r:"data.CreateDate" },
                " ",
                { t:7,
                  e:"br" },
                { t:7,
                  e:"br" },
                " ",
                { t:7,
                  e:"h4",
                  f:[ "Confirmation Number: ",
                    { t:2,
                      r:"data.LabelConfirmationNumber" } ] },
                " ",
                { t:4,
                  f:[ { t:7,
                      e:"div",
                      f:[ { t:4,
                          f:[ { t:7,
                              e:"h4",
                              f:[ "Travelport Record Locator: ",
                                { t:7,
                                  e:"a",
                                  a:{ href:"#" },
                                  v:{ click:"onCompareClick" },
                                  f:[ { t:2,
                                      r:"data.MyRecLoc" } ] } ] } ],
                          n:50,
                          x:{ r:[ "data.MyRecLoc" ],
                            s:"_0!=\"none\"" } },
                        " ",
                        { t:4,
                          f:[ "Loading..." ],
                          n:50,
                          r:"loadingTpDiffs" },
                        " ",
                        { t:4,
                          f:[ { t:7,
                              e:"ul",
                              a:{ "class":"normalList" },
                              f:[ { t:4,
                                  f:[ { t:7,
                                      e:"li",
                                      f:[ { t:3,
                                          r:"." } ] } ],
                                  n:52,
                                  r:"tpDiffs" } ] } ],
                          n:50,
                          x:{ r:[ "loadingTpDiffs",
                              "tpDiffs.length" ],
                            s:"!_0&&_1>0" } } ] } ],
                  n:50,
                  x:{ r:[ "isDba",
                      "tpDiffs" ],
                    s:"_0&&_1!=null" } },
                " ",
                { t:7,
                  e:"div",
                  f:[ { t:3,
                      r:"data.LinkButtonCancel" } ] } ] },
            " ",
            { t:7,
              e:"br" },
            " ",
            { t:7,
              e:"div",
              f:[ { t:7,
                  e:"h4",
                  f:[ { t:7,
                      e:"a",
                      a:{ href:[ { t:2,
                            x:{ r:[ "getDetailLink",
                                "data.MyHotelID",
                                "data.MyProviderCode",
                                "data.MyBookingRegion" ],
                              s:"_0(_1,_2,_3)" } } ] },
                      f:[ { t:2,
                          r:"data.MyHotelPublicName" } ] } ] },
                " ",
                { t:4,
                  f:[ { t:4,
                      n:53,
                      f:[ { t:8,
                          r:"hotelRating" } ],
                      r:"data.LabelHotelCategory" },
                    " ",
                    { t:7,
                      e:"br" },
                    " ",
                    { t:7,
                      e:"br" } ],
                  n:50,
                  r:"data.LabelHotelCategory" },
                " ",
                { t:2,
                  r:"data.LabelAddress" },
                " ",
                { t:7,
                  e:"br" },
                " ",
                { t:2,
                  r:"data.LabelPhone" },
                " ",
                { t:7,
                  e:"br",
                  a:{ clear:"all" } },
                " ",
                { t:7,
                  e:"br" },
                " Occupants: ",
                { t:2,
                  r:"data.travelers" },
                " ",
                { t:4,
                  f:[ { t:7,
                      e:"br" },
                    " ",
                    { t:2,
                      r:"data.childrenAges" } ],
                  n:50,
                  r:"data.childrenAges" },
                " ",
                { t:7,
                  e:"br" },
                { t:7,
                  e:"br" },
                " Check-in: ",
                { t:2,
                  r:"data.LabelFromDate" },
                " ",
                { t:7,
                  e:"br" },
                " Check-out: ",
                { t:2,
                  r:"data.LabelToDate" },
                " ",
                { t:7,
                  e:"br" },
                " ",
                { t:7,
                  e:"br" },
                " ",
                { t:2,
                  r:"data.LabelNumberOfNights" },
                " | ",
                { t:2,
                  r:"data.LabelRoomCount" },
                " room/suite" ] },
            " ",
            { t:7,
              e:"br" },
            " ",
            { t:7,
              e:"div",
              f:[ { t:7,
                  e:"h4",
                  f:[ "Name on Reservation" ] },
                " ",
                { t:2,
                  r:"data.LiteralName" },
                " ",
                { t:7,
                  e:"br" },
                " ",
                { t:3,
                  r:"data.LiteralAddress" },
                " ",
                { t:7,
                  e:"br" },
                " ",
                { t:7,
                  e:"br" },
                " ",
                { t:2,
                  r:"data.LiteralEMail" },
                " ",
                { t:7,
                  e:"br" },
                " ",
                { t:2,
                  r:"data.LiteralPhone" },
                " ",
                { t:7,
                  e:"br" },
                " ",
                { t:7,
                  e:"br" },
                " ",
                { t:4,
                  f:[ " Message for hotel: ",
                    { t:2,
                      r:"data.LabelRemark" } ],
                  n:50,
                  x:{ r:[ "data.LabelRemark" ],
                    s:"_0!==\"\"" } } ] },
            " ",
            { t:7,
              e:"a",
              a:{ href:"javascript:window.print()",
                "class":"btn btn-primary" },
              f:[ "Print" ] },
            " ",
            { t:7,
              e:"br" },
            { t:7,
              e:"br" },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"a",
                  a:{ "class":"fh-button-green fh-icon--check",
                    href:[ "./about/fareharbor/?dest=",
                      { t:2,
                        r:"data.RegionName" } ],
                    target:"_blank" },
                  f:[ "Local Activities(",
                    { t:2,
                      r:"data.LocalActivities" },
                    ")" ] },
                " ",
                { t:7,
                  e:"br" },
                { t:7,
                  e:"br" } ],
              n:50,
              x:{ r:[ "data.LocalActivities" ],
                s:"_0>0" } } ] },
        " ",
        { t:7,
          e:"div",
          a:{ "class":"span8",
            id:"vacationDetailsBookspan8" },
          f:[ { t:7,
              e:"h4",
              f:[ "Room" ] },
            " ",
            { t:7,
              e:"span",
              a:{ "class":"tdLike" },
              f:[ { t:2,
                  r:"data.LabelRoomCode" } ] },
            " ",
            { t:7,
              e:"br" },
            " ",
            { t:7,
              e:"span",
              a:{ "class":"tdLike" },
              f:[ { t:3,
                  r:"data.LabelRoomDescription" } ] },
            " ",
            { t:7,
              e:"br" },
            " ",
            { t:7,
              e:"br" },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"h4",
                  f:[ "Special Request for the Hotelier:" ] },
                " ",
                { t:7,
                  e:"span",
                  a:{ style:"font-style:italic",
                    "class":"tdLike" },
                  f:[ { t:2,
                      r:"data.LiteralSpecialRequest" } ] },
                " ",
                { t:7,
                  e:"br" },
                " ",
                { t:7,
                  e:"br" } ],
              n:50,
              r:"data.LiteralSpecialRequest" },
            " ",
            { t:7,
              e:"table",
              a:{ "class":"table table-striped table-bordered paymentTable" },
              f:[ { t:7,
                  e:"tr",
                  f:[ { t:7,
                      e:"th",
                      f:[ "Nightly Reservation Costs" ] },
                    " ",
                    { t:7,
                      e:"td",
                      f:[ "What Your Vacation Costs" ] },
                    " ",
                    { t:7,
                      e:"td",
                      f:[ "Percentage Paid To Date" ] } ] },
                " ",
                { t:7,
                  e:"tr",
                  f:[ { t:7,
                      e:"td",
                      a:{ "class":"leftAligned" },
                      f:[ "Total Room Cost" ] },
                    " ",
                    { t:7,
                      e:"td",
                      f:[ { t:7,
                          e:"div",
                          f:[ { t:2,
                              r:"data.LabelRoomRate" } ] },
                        " ",
                        { t:7,
                          e:"a",
                          a:{ href:"#roomCostDetails",
                            "class":"infoLink sideNote" },
                          f:[ "details" ] },
                        " ",
                        { t:7,
                          e:"div",
                          a:{ id:"roomCostDetails",
                            "class":"infoBox" },
                          f:[ { t:3,
                              r:"data.roomRateNightlyTable" } ] } ] },
                    " ",
                    { t:7,
                      e:"td",
                      f:[ { t:2,
                          r:"data.AppliedRoomCost" } ] } ] },
                " ",
                { t:7,
                  e:"tr",
                  f:[ { t:7,
                      e:"td",
                      a:{ "class":"leftAligned" },
                      f:[ "Hotel Tax Pass Through",
                        { t:7,
                          e:"sup",
                          a:{ style:"color:red;" },
                          f:[ "*" ] } ] },
                    " ",
                    { t:7,
                      e:"td",
                      f:[ { t:2,
                          r:"data.LabelTaxFee" } ] },
                    " ",
                    { t:7,
                      e:"td",
                      f:[ { t:2,
                          r:"data.AppliedTax" } ] } ] },
                " ",
                { t:4,
                  f:[ { t:7,
                      e:"tr",
                      f:[ { t:7,
                          e:"td",
                          a:{ "class":"leftAligned" },
                          f:[ "Resort Fees" ] },
                        " ",
                        { t:7,
                          e:"td",
                          f:[ { t:2,
                              r:"data.labelResortFee" } ] },
                        " ",
                        { t:7,
                          e:"td",
                          f:[ { t:2,
                              r:"data.AppliedResortFees" } ] } ] } ],
                  n:50,
                  x:{ r:[ "data.labelResortFee" ],
                    s:"_0!=\"$0.00\"" } },
                " ",
                { t:4,
                  f:[ { t:7,
                      e:"tr",
                      a:{ id:"trProcessingFee" },
                      f:[ { t:7,
                          e:"td",
                          a:{ "class":"leftAligned" },
                          f:[ "Processing Fee" ] },
                        " ",
                        { t:7,
                          e:"td",
                          f:[ { t:2,
                              r:"data.LiteralProcessingFee" } ] },
                        " ",
                        { t:7,
                          e:"td",
                          f:[ { t:2,
                              r:"data.AppliedProcessingFee" } ] } ] } ],
                  n:50,
                  x:{ r:[ "MyProcessingFee" ],
                    s:"_0>0" } },
                " ",
                { t:7,
                  e:"tr",
                  a:{ "class":"thickLine" },
                  f:[ { t:7,
                      e:"th",
                      a:{ "class":"leftAligned" },
                      f:[ "Total" ] },
                    " ",
                    { t:7,
                      e:"td",
                      f:[ { t:2,
                          r:"data.LabelRoomRateInclusive" } ] },
                    " ",
                    { t:7,
                      e:"td",
                      f:[ { t:2,
                          r:"data.AppliedTotal" } ] } ] } ] },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"span",
                  a:{ "class":"tdLike",
                    style:"font-style:italic;" },
                  f:[ "Payable through ",
                    { t:2,
                      r:"data.LabelSupplierName" },
                    ", acting as agent for the service operating company, details of which can be provided upon request. VAT: ",
                    { t:2,
                      r:"data.LabelVatNumber" },
                    " Reference: ",
                    { t:2,
                      r:"data.LabelConfirmationNumber" },
                    "." ] },
                " ",
                { t:7,
                  e:"br" } ],
              n:50,
              x:{ r:[ "data.MyBookingSource",
                  "data.LabelSupplierName",
                  "data.LabelVatNumber" ],
                s:"_0==\"hotelbeds\"&&_1&&_2" } },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"br" },
                " ",
                { t:7,
                  e:"div",
                  a:{ "class":"alert alert-warning vacation-review-alert",
                    role:"alert" },
                  f:[ { t:7,
                      e:"div",
                      a:{ style:"display: inline; color: #353535; font-weight: bold;" },
                      f:[ "This property is charging ",
                        { t:2,
                          r:"data.LabelExcludedTax" },
                        " for ",
                        { t:2,
                          x:{ r:[ "data.LiteralExcludedNote" ],
                            s:"_0?_0:\"additional charges\"" } },
                        ". These must be paid directly to the property at time of check-in. You cannot use your adestinn savings to pay any of these charges. The amount shown here is an estimate based on the information available at the time of booking. The actual amount may vary at time of check-in. ",
                        { t:7,
                          e:"a",
                          a:{ href:"#extra-charges-question-modal",
                            "class":"infoLink",
                            "data-track":"ReviewBooking,Help,ResortFees,1" },
                          f:[ { t:7,
                              e:"img",
                              a:{ src:"https://adestinn2blob.blob.core.windows.net/images/ico-question.png",
                                alt:"what's this" } } ] },
                        " ",
                        { t:4,
                          f:[ { t:7,
                              e:"ul",
                              a:{ style:"list-style-type: disc; margin: 10px 0 10px 25px;" },
                              f:[ { t:4,
                                  f:[ { t:7,
                                      e:"li",
                                      f:[ { t:2,
                                          r:".Amount" },
                                        " - ",
                                        { t:4,
                                          f:[ { t:2,
                                              r:".Description" } ],
                                          n:50,
                                          x:{ r:[ ".Description" ],
                                            s:"_0!=null" } },
                                        { t:4,
                                          n:51,
                                          f:[ "Type Not Provided" ],
                                          x:{ r:[ ".Description" ],
                                            s:"_0!=null" } },
                                        " ",
                                        { t:4,
                                          f:[ "(",
                                            { t:2,
                                              r:".Currency" },
                                            ")" ],
                                          n:50,
                                          x:{ r:[ ".Currency" ],
                                            s:"_0!=null&&_0!=\"USD\"" } } ] } ],
                                  n:52,
                                  r:"data.LiteralHotelExcludedTaxes" } ] } ],
                          n:50,
                          x:{ r:[ "data.MyProviderCode" ],
                            s:"_0==1" } } ] } ] },
                " ",
                { t:7,
                  e:"div",
                  a:{ id:"extra-charges-question-modal",
                    "class":"infoBox ps-infobox" },
                  f:[ "Some properties have extra charges such as resort fees and miscellaneous taxes. These must be paid directly to the property at check-in. You cannot use your Adestinn savings to pay any of these charges. The amount shown here is an estimate based on the information available at the time of booking. The actual amount may vary at time of check-in." ] } ],
              n:50,
              x:{ r:[ "data.LabelExcludedTax" ],
                s:"_0!=\"$0.00\"" } },
            " ",
            { t:7,
              e:"br" },
            " ",
            { t:7,
              e:"h4",
              f:[ "Policies:" ] },
            " ",
            { t:7,
              e:"br" },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"span",
                  f:[ "Promotions:" ] },
                " ",
                { t:7,
                  e:"ul",
                  f:[ { t:4,
                      f:[ { t:7,
                          e:"li",
                          f:[ "* ",
                            { t:2,
                              r:".Name" } ] } ],
                      n:52,
                      r:"data.LiteralPromotions" } ] },
                " ",
                { t:7,
                  e:"br" } ],
              n:50,
              x:{ r:[ "data.LiteralPromotions.length" ],
                s:"_0>0" } },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"span",
                  f:[ "Offers:" ] },
                " ",
                { t:7,
                  e:"ul",
                  f:[ { t:4,
                      f:[ { t:7,
                          e:"li",
                          f:[ "* ",
                            { t:2,
                              r:".Name" },
                            ": ",
                            { t:2,
                              r:".Amount" } ] } ],
                      n:52,
                      r:"data.LiteralOffers" } ] },
                " ",
                { t:7,
                  e:"br" } ],
              n:50,
              x:{ r:[ "data.LiteralOffers.length" ],
                s:"_0>0" } },
            " ",
            { t:4,
              f:[ { t:2,
                  r:"data.LabelRatePlanDescription" },
                " ",
                { t:7,
                  e:"br" } ],
              n:50,
              r:"data.LabelRatePlanDescription" },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"table",
                  a:{ "class":"table table-striped table-bordered" },
                  f:[ { t:7,
                      e:"th",
                      f:[ "Cancellation ",
                        { t:7,
                          e:"span",
                          a:{ style:"float: right; font-style:italic; font-size: 12px;" },
                          f:[ "*All times are based in the hotels timezone" ] } ] },
                    " ",
                    { t:4,
                      f:[ { t:7,
                          e:"tr",
                          f:[ { t:7,
                              e:"td",
                              m:[ { t:4,
                                  f:[ "class=\"cancellation-highlight\"" ],
                                  n:50,
                                  r:".InEffect" } ],
                              f:[ "If cancelled on or after ",
                                { t:7,
                                  e:"strong",
                                  f:[ { t:2,
                                      r:".From" } ] },
                                " ",
                                { t:7,
                                  e:"a",
                                  a:{ href:"#cancellation-price-modal",
                                    "class":"infoLink" },
                                  f:[ { t:7,
                                      e:"img",
                                      a:{ src:"https://adestinn2blob.blob.core.windows.net/images/ico-question.png",
                                        alt:"cancellation price information" } } ] } ] },
                            " ",
                            { t:7,
                              e:"td",
                              m:[ { t:4,
                                  f:[ "class=\"cancellation-highlight\"" ],
                                  n:50,
                                  r:".InEffect" } ],
                              f:[ { t:7,
                                  e:"strong",
                                  f:[ { t:2,
                                      r:".Amount" } ] } ] } ] } ],
                      n:52,
                      r:"data.LiteralCancellationPolicies" } ] } ],
              n:50,
              x:{ r:[ "data.LiteralCancellationPolicies.length" ],
                s:"_0>0" } },
            { t:4,
              n:51,
              f:[ { t:4,
                  f:[ { t:7,
                      e:"table",
                      a:{ "class":"table table-striped table-bordered" },
                      f:[ { t:7,
                          e:"th",
                          f:[ "Cancellation ",
                            { t:7,
                              e:"span",
                              a:{ style:"float: right; font-style:italic; font-size: 12px;" },
                              f:[ "*All times are based in the hotels timezone" ] } ] },
                        " ",
                        { t:7,
                          e:"tr",
                          f:[ { t:7,
                              e:"td",
                              a:{ "class":"cancellation-highlight" },
                              f:[ { t:7,
                                  e:"strong",
                                  f:[ "This vacation is non-refundable" ] },
                                " ",
                                { t:7,
                                  e:"a",
                                  a:{ href:"#cancellation-price-modal",
                                    "class":"infoLink" },
                                  f:[ { t:7,
                                      e:"img",
                                      a:{ src:"https://adestinn2blob.blob.core.windows.net/images/ico-question.png",
                                        alt:"cancellation price information" } } ] } ] } ] } ] } ],
                  n:50,
                  x:{ r:[ "data.MyProviderCode" ],
                    s:"_0==1" } },
                { t:4,
                  n:51,
                  f:[ { t:2,
                      r:"data.LabelCancelPolicy" } ],
                  x:{ r:[ "data.MyProviderCode" ],
                    s:"_0==1" } } ],
              x:{ r:[ "data.LiteralCancellationPolicies.length" ],
                s:"_0>0" } },
            " ",
            { t:7,
              e:"p",
              f:[ "The total above includes only the cost of the room, taxes and any mandatory resort fees the hotel charges." ] },
            " ",
            { t:7,
              e:"p",
              f:[ { t:7,
                  e:"sup",
                  a:{ style:"color:red;" },
                  f:[ "*" ] },
                " Taxes are estimated at the time of booking based on the current tax information provided by the property. If the tax amount changes by check out, we will adjust your VSA accordingly." ] },
            " Any incidental charges you incur such as room service, mini-bar, movies, spa services, parking, and others are not included in the above total. All hotels require a credit or debit card at check-in (contact the property's front desk to find out about their hold policy). A hold (of one night stay up to the full amount, depending on each property's policy) will be placed on your card and will come off at check-out (may take up to 10 business days if you use a debit card). Contact member services if you need more information. ",
            { t:3,
              r:"data.hotelSpecialMessages" },
            " ",
            { t:7,
              e:"br" },
            { t:7,
              e:"br" },
            " ",
            { t:7,
              e:"a",
              a:{ href:"/#/faq/hotel-arrival" },
              f:[ "What should I be aware of when I arrive?" ] },
            " ",
            { t:7,
              e:"div",
              a:{ id:"cancellation-price-modal",
                "class":"infoBox ps-infobox" },
              f:[ "If this booking is canceled on or after the date show, the property will impose a cancellation penalty on this booking in the amount shown. This will be automatically subtracted from your VSA balance. ",
                { t:7,
                  e:"br" },
                { t:7,
                  e:"br" },
                " Non-refundable vacations cannot be canceled at any time and must be fully funded." ] } ] } ],
      x:{ r:[ "data.LabelError" ],
        s:"_0!=\"\"" } } ] };});
